<div style="text-align: center;">
  <i class="fas fa-solid fa-check"></i>
  <h6 class="text-nowrap" style="margin-top: 10px;font-size: 12px;">{{message}}</h6>
</div>
